// Shared markdown-lite parsing for owner-written articles.
// Supported: "# / ## " => section heading (level 2), "### " => subheading (level 3),
// blank line => new paragraph, **bold** inline.

export function parseContent(content) {
  const sections = [];
  let cur = { heading: "", level: 2, body: [] };
  let para = [];
  const flush = () => { if (para.length) { cur.body.push(para.join(" ")); para = []; } };
  (content || "").split("\n").forEach((raw) => {
    const line = raw.trim();
    const m = line.match(/^(#{1,3})\s+(.*)$/);
    if (m) {
      flush();
      if (cur.heading || cur.body.length) sections.push(cur);
      cur = { heading: m[2].trim(), level: m[1].length >= 3 ? 3 : 2, body: [] };
    } else if (!line) {
      flush();
    } else {
      para.push(line);
    }
  });
  flush();
  if (cur.heading || cur.body.length) sections.push(cur);
  return sections;
}

// Render **bold** segments inline. Returns an array of React nodes.
export function renderInline(text) {
  const parts = (text || "").split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => {
    if (/^\*\*[^*]+\*\*$/.test(p)) {
      return <strong key={i} className="font-bold text-white">{p.slice(2, -2)}</strong>;
    }
    return <span key={i}>{p}</span>;
  });
}
